/*
 * Copyright (c) 2022 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React from 'react';

const LocationResultCardMarker = ({ pathFill, locationIndex }) => {
  return (
    <div
      className="card-marker-container"
      aria-label={`location ${locationIndex + 1}`}
      id={`map-marker-${locationIndex + 1}-svg`}
    >
      <svg
        role="img"
        width="34"
        height="48"
        viewBox="0 0 34 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>{`location ${locationIndex + 1}`}</title>
        <path
          d="M4.23426 27.8896L4.23509 27.891C5.3434 29.6876 6.63135 31.3634 7.95895 33.0854L8.01486 33.1579C9.31441 34.8434 10.65 36.5757 11.816 38.446M4.23426 27.8896L10.968 38.976M4.23426 27.8896C2.1408 24.5079 1 20.7766 1 16.8C1 8.06429 8.06428 1 16.8 1C25.5357 1 32.6 8.06429 32.6 16.8C32.6 20.7763 31.4594 24.5059 29.3443 27.8855L29.3443 27.8855L29.3394 27.8934C28.2315 29.7011 26.9437 31.3827 25.617 33.1034C25.5772 33.1551 25.5374 33.2067 25.4975 33.2584C24.2187 34.9167 22.9076 36.6171 21.7609 38.4445L21.7606 38.445C20.595 40.3051 19.78 42.037 18.8904 43.9845L18.8896 43.9862C18.7756 44.237 18.6591 44.5333 18.5497 44.8116C18.5042 44.9274 18.4599 45.04 18.4175 45.145C18.2608 45.533 18.1054 45.8837 17.927 46.1831C17.5742 46.7751 17.2428 47 16.8 47C16.3571 47 16.0252 46.7751 15.6685 46.1805C15.4881 45.8799 15.3304 45.5282 15.1697 45.1383C15.1306 45.0435 15.0901 44.9431 15.0485 44.8401C14.933 44.5538 14.8092 44.2471 14.6852 43.9836M4.23426 27.8896L13.776 44.4M11.816 38.446C11.8162 38.4463 11.8164 38.4467 11.8166 38.447L10.968 38.976M11.816 38.446C11.8158 38.4456 11.8156 38.4453 11.8154 38.445L10.968 38.976M11.816 38.446C12.9775 40.2996 13.8144 42.0247 14.6852 43.9836M10.968 38.976C12.096 40.776 12.912 42.456 13.776 44.4M14.6852 43.9836C14.6835 43.9799 14.6818 43.9763 14.6801 43.9726L13.776 44.4M14.6852 43.9836C14.6868 43.987 14.6883 43.9904 14.6898 43.9939L13.776 44.4"
          fill={pathFill}
          stroke="white"
          strokeWidth="2"
        />
      </svg>
      <div className={locationIndex + 1 >= 10 ? 'marker-number-sm' : 'marker-number'}>
        {locationIndex + 1}
      </div>
    </div>
  );
};

export default React.memo(LocationResultCardMarker);
